export const detectPromotionIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete promotion" || cleaned === "remove promotion") {
        return { intent: "delete_promotion" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) promotion/);
    if (deleteMatch) {
        return { intent: "delete_promotion", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create promotion") || cleaned.includes("add promotion")) {
        return { intent: "create_promotion" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create promotion named (.+)/);
    if (createMatch) {
        return { intent: "create_promotion", name: createMatch[1].trim() };
    }

    return null;
};
